import axios from "axios";

import { API_URL as API } from "./config";

function toKey(b64) {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export const supportate = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export async function registraSW() {
  if (!("serviceWorker" in navigator)) return null;
  return navigator.serviceWorker.register("/sw.js");
}

export async function statoNotifiche() {
  if (!supportate()) return "non-supportate";
  if (Notification.permission === "denied") return "negate";
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg && (await reg.pushManager.getSubscription());
  return sub ? "attive" : "spente";
}

export async function attivaNotifiche() {
  if (!supportate()) throw new Error("Questo browser non supporta le notifiche push");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Permesso notifiche negato");
  const reg = (await navigator.serviceWorker.getRegistration()) || (await registraSW());
  await navigator.serviceWorker.ready;
  const { data } = await axios.get(`${API}/push/vapid-public-key`);
  let sub = await reg.pushManager.getSubscription();
  if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toKey(data.key) });
  await axios.post(`${API}/push/subscribe`, { sub: sub.toJSON() });
  return sub;
}

export async function disattivaNotifiche() {
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg && (await reg.pushManager.getSubscription());
  if (sub) {
    await axios.delete(`${API}/push/subscribe`, { params: { endpoint: sub.endpoint } }).catch(() => {});
    await sub.unsubscribe();
  }
}

export const provaNotifica = () => axios.post(`${API}/push/test`);
